export default __webpack_public_path__ + "static/media/backer-j8ventures.36c4e1e1.png";